// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticleRedactor__payloads-a5b81d {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/ArticleRedactor/ArticleRedactor.styles.m.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF","sourcesContent":[".payloads {\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"payloads": `ArticleRedactor__payloads-a5b81d`
};
module.exports = ___CSS_LOADER_EXPORT___;
